import React from "react";
import '../styles/patientselection.css';
import bg from '../assets/images/patient.jpg';
import { Spin } from "antd";

const PatientSelection = (props) => {
    return (
        <div className="patient-selection-container">
            {!props.isLoading ? 
                <>
                <div className="image-container">
                    <img src={bg} alt="bg"/>
                </div>
                <div className="text-headers">
                    <div className="main-head">
                        Select a patient
                    </div>
                    <div className="sub-head">
                        We found more than one patients registered with the mobile number you entered
                    </div>
                </div>
                <div className="patients-list">
                    {props.patients.map((p) =>
                        <div className="patient-item" key={p.patientId}>
                            <div className="text-content">
                                <div className="name">
                                    {p.patientName}
                                </div>
                                <div className="mrno">
                                    {p.mrnNo}
                                </div>
                            </div>
                            <div className="action-content">
                                <i className="las la-chevron-circle-right" onClick={() => { props.onSelect(p); }}/>
                            </div>
                        </div>
                    )}
                </div>
                <div className="back-button-container">
                        <div className="back-button" onClick={() => {window.location.href='/'}}>
                        <i className="las la-angle-left"/>
                    </div>
                </div>
                </> :
                <div className="loader-screen">
                    <Spin></Spin>
                </div>
            }
        </div>
    )
}
export default PatientSelection;